module.exports = __webpack_public_path__ + "img/weather61.6ae3c570.png";